import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';

// import EditFormLocation from '../../../HR/settings/Location/EditLocation/EditFormLocation';
import useLocationDetails from '../../../../hooks/Lookups/use-location-details';

const UppdateLocations = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();

  // const { Location, loading, error } = useLocationDetails();
  // const { Location, loading , error } = useLocationDetails();

  //______________________________
  
  return (
    <div>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
           link: ':moduleHome'
          },
          {
            name: '',
            link: '/FLEETSettings/Locations'
          },
          {
            name: 'Edit',
            link: null
          }
        ]}
        PageName='EditLocation'
      />

      <Card>
        {/* <Loader loading={loading} /> */}

        <CardBody>
          {/* {Object.keys(Location)?.length > 0 && (
            <EditFormLocation Location={Location} loading={loading} />
          )} */}
        </CardBody>
      </Card>
    </div>
  );
};

export default UppdateLocations;
